import { OAuth2Config } from './utils/AuthTypes';

const authUrl: string = process.env.REACT_APP_AUTH_URL !== null && process.env.REACT_APP_AUTH_URL !== undefined
  ? process.env.REACT_APP_AUTH_URL
  : 'http://localhost:8080/mms3-auth';

const publicUrl: string = process.env.REACT_APP_PUBLIC_URL !== null && process.env.REACT_APP_PUBLIC_URL !== undefined
  ? process.env.REACT_APP_PUBLIC_URL
  : 'http://localhost:3000';

export const oauth2Config: OAuth2Config = {
  authUrl: `${authUrl}/oauth2/authorize`,
  tokenUrl: `${authUrl}/oauth2/token`,
  clientId: 'frontend',
  clientSecret: 'fa6Fkxf4K9GHwvTV',
  flowType: 'code',

  logoutUrl: `${authUrl}/logout`,
};

export interface Request {
  code?: string;
  grant_type: 'authorization_code';
  client_secret: string;
  redirect_uri: string;
  client_id: string;
}

export const getRequest = (authCode: string): Request => ({
  grant_type: 'authorization_code',
  code: authCode,
  client_id: oauth2Config.clientId,
  client_secret: oauth2Config.clientSecret,
  redirect_uri: window.location.protocol + '//' + window.location.host + '/oauth',
});

export interface RefreshRequest {
  grant_type: 'refresh_token';
  refresh_token: string;
  client_id: string;
  client_secret: string;
}

export const getRefreshRequest = (refresh: string): RefreshRequest => ({
  grant_type: 'refresh_token',
  refresh_token: refresh,
  client_id: oauth2Config.clientId,
  client_secret: oauth2Config.clientSecret,
});
